export default {
  back: 'Retour au menu',
  menu: 'Menu',
};
